import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';

const apiHttpLink = createHttpLink({
  uri: process.env.REACT_APP_API_URI
});

const systemsAuthLink = setContext((_, { headers }) => {
  const token = localStorage.getItem('auth-token') || process.env.REACT_APP_TOKEN;

  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : ''
    }
  };
});

const cache = new InMemoryCache({
  typePolicies: {
    Subscription: {
      fields: {}
    },
    Query: {
      fields: {}
    }
  }
});

const client = new ApolloClient({
  link: systemsAuthLink.concat(apiHttpLink),
  cache
});

export { client };
